var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeofence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Geofence",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_pin_drop_24px",
    className: "cls-2",
    d: "M16.383,7.254a5.254,5.254,0,1,0-10.507,0c0,3.94,5.254,9.632,5.254,9.632S16.383,11.194,16.383,7.254Zm-7,0A1.751,1.751,0,1,1,11.129,9,1.756,1.756,0,0,1,9.378,7.254ZM5,17.761v1.751H17.258V17.761Z",
    transform: "translate(-1.448 -1.127)",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofence);
export default __webpack_public_path__ + "static/media/Geofence.b1ed4d003efb8f9f316fecf6373d9584.svg";
export { ForwardRef as ReactComponent };